import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import { Card, CardContent } from "../../components/ui/card";
import { toast } from "sonner";

const FIELDS = [
  { key: "display_text", label: "Header display text (shown on /pay/:token when Stripe not connected)" },
  { key: "check_instructions", label: "Check instructions" },
  { key: "ach_instructions", label: "ACH instructions" },
  { key: "zelle_instructions", label: "Zelle instructions" },
  { key: "wire_instructions", label: "Wire instructions" },
];

export default function PaymentsFallback() {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { setForm((await api.get("/payments-fallback")).data || {}); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.patch("/payments-fallback", form);
      toast.success("Instructions saved");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AppShell title="Payments Fallback Instructions" subtitle="Shown on /pay/:token because online payments are not enabled">
      <div className="max-w-2xl">
        <Card className="border-erf-borderCream" data-testid="pf-card">
          <CardContent className="p-5 space-y-4">
            {FIELDS.map((f) => (
              <div key={f.key}>
                <Label className="text-xs uppercase font-nav">{f.label}</Label>
                <Textarea value={form[f.key] || ""} onChange={(e)=>setForm({...form, [f.key]: e.target.value})} className="mt-1" rows={3} data-testid={`pf-${f.key}`} />
              </div>
            ))}
            <Button onClick={save} disabled={busy} className="bg-erf-gold text-erf-dark hover:bg-erf-goldHover" data-testid="pf-save">
              {busy ? "Saving…" : "Save instructions"}
            </Button>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
